import { Component, OnInit } from '@angular/core';
import { Product } from '../../interfaces/Product.interface';
import { Image } from '../../interfaces/Product.interface';
import { CatalogoService } from '../../services/catalogo.service';
import { EnceService } from '../../services/ence.service';
declare var $ :any;


@Component({
  selector: 'app-catalogo',
  templateUrl: './catalogo.component.html',
  styleUrls: ['./catalogo.component.css'],
  providers: [EnceService]
})

export class CatalogoComponent implements OnInit {

  public infoDetailProduct:any;
  public viewDetail:boolean;
  public viewDetail2:boolean;
  public viewDetail3:boolean;
  public viewDetail4:boolean;
  public viewDetail5:boolean;
  public products: Array<any>;
  public responseText:string;
  public responseText2:string;
  public product: Product;
  public arrGrande: Array<any> = [];
  public inauxx:number;
  public indexaux:number;
  public isActive:boolean;
  public codProdOpen:number;
  public detectChanges:boolean;
  public valueLang:string;
  public valueLangAux:string;

  public loaderCatalogo:boolean;

  public subInterval:any;

  constructor(
    private catalogoService: CatalogoService,
    public _enceService: EnceService
  ) {
    this.viewDetail=false;
    this.viewDetail2=false;
    this.viewDetail3=false;
    this.viewDetail4=false;
    this.viewDetail5=false;
    this.products=[];
    this.indexaux=0;
    this.codProdOpen=0;
    this.detectChanges=false;
    this.loaderCatalogo=false;
  }



  ngOnInit() {
    this.valueLang=sessionStorage.getItem('lang');
    this.subInterval = setInterval(()=>{
      this.valueLangAux=sessionStorage.getItem('lang');
      if(this.valueLang!==this.valueLangAux){
        this.getProductsList();
        this.valueLang=this.valueLangAux;
      }
    },50);

    this.getProductsList();
    this.responseText='No existen productos.';

  }

  ngOnDestroy(): void {
    clearInterval(this.subInterval);
  }


public activeDetail(codprod, i){

  var $cell = $('.image__cell');
  if(!this.viewDetail){
    var $thisCell = $('#prod'+codprod);
    this.viewDetail=false;
    this.codProdOpen=codprod;
  } else {
    var $thisCell = $('#prod'+this.codProdOpen);
    this.viewDetail=true;
  }
  if ($thisCell.hasClass('is-collapsed')) {
      $cell.not($thisCell).removeClass('is-expanded').addClass('is-collapsed');
      $thisCell.removeClass('back-clean').addClass('back-colored');
      $thisCell.removeClass('is-collapsed').addClass('is-expanded');
   } else {
     $thisCell.removeClass('is-expanded').addClass('is-collapsed');
     $thisCell.removeClass('back-colored').addClass('back-clean');
   }
   this.getItemDetail(codprod, i);
   }


public getItemDetail(codProd, i){
    if(this.viewDetail){
      this.viewDetail=false;
    }else{
      this.viewDetail=true;
    }
  this.product=this.products[i];
}

public closeDetail(){
  var $cell = $('.image__cell');
  var $thisCell = $('#prod'+this.codProdOpen);
    if ($thisCell.hasClass('is-collapsed')) {
      $cell.not($thisCell).removeClass('is-expanded').addClass('is-collapsed');
      $thisCell.removeClass('is-collapsed').addClass('is-expanded');
   } else {
     $thisCell.removeClass('is-expanded').addClass('is-collapsed');
   }
}

  /**
   * Funcion que muestra el detalle del producto
   */
  public getProduct(){

    if(this.viewDetail){
      this.viewDetail=false;
    }else{
      this.viewDetail=true;
    }
  }

  /**
   * Function que hace la peticion de productos
   */
  public getProductsList() {
    this.loaderCatalogo = true;
    this.products = [];

    this.catalogoService.getProducts().subscribe({
      next: (response: any) => {
        if (response.success && response.data && response.data.products) {
          if (response.data.products.length === 0) {
            this.products = [];
            this.responseText = 'No se ha encontrado ningun producto.';
          } else {
            this.products = response.data.products;
            this.formatArrayProducts(this.products);
          }
        } else {
          this.responseText = 'Error al cargar los productos.';
        }
        this.loaderCatalogo = false;
      },
      error: (error) => {
        console.error('Error al obtener productos:', error);
        this.responseText = 'Error al cargar los productos.';
        this.loaderCatalogo = false;
      }
    });
  }
  /**
   * Funcion que formatea el array de productos para evitar undefined o null
   */
  public formatArrayProducts(arrayProductos: Array<Product>):void{
    let imageDefault: Image = {
      id:'',
      name:'',
      type:'',
      filename:'',
      url:'../../../assets/images/no-image.png',
      caption:'',
      order:'',
      entity_id:'',
      created_at:'',
      updated_at:''
    };

    for(let product of arrayProductos){
      if(product.picture === undefined || product.picture===null){
        product.picture = imageDefault;
      }
    }
    this.products=arrayProductos;
  }

  /**
   * Funcion que hace la peticion de detalle de un componente
   */
  public openViewDetail(codprop){
    $('#'+codprop).css('display','block');
    this.viewDetail=true;
  }



  public setId(codprod){
    return '#'+codprod;
  }

  public setCollapse(id){
    return 'collapse'+id;
  }


}
